import { store } from '../store'
import {isAuthToEdit, isAuthToReports, isAuthToAudits, isAuthToFieldSurveys} from '../lib/helpers'
import i18n from '@/lib/i18n'
import isEmpty from 'lodash/isEmpty'

/**
 * Route guard: public routes, sign-in redirect, role-based access, and bootstrap via /loading when the app is not ready.
 */
export default (to, from, next) => {
  const token = store.getters.userAuth
  const impersonated = store.getters.impersonatedUserId
  const user = store.getters.user
  const publicRoute = ['Welcome'].includes(to.name)
  const routeInit = ['/signin'].includes(to.fullPath)
  const crudRoutes = ['/organizationHome', '/addDevice', '/addUser', '/editUser', '/addCrop', '/addField', '/manageField']
  const reportRoutes = ['/reports']
  const auditRoutes = ['/audits']
  document.title = routeInit ? `PONCE | ${i18n.t('WebTitles.login')}` : to.fullPath === '/reports' ? `PONCE | ${i18n.t('WebTitles.reports')}` : to.fullPath.includes('/loading') ? 'PONCE' : `PONCE | ${i18n.t('WebTitles.dashboard')}`

  // Short-link flow: skip strict checks so /loading can resolve the target URL
  if (to.fullPath.includes('/r/') || (to.query.to && to.query.to.includes('/r/'))) {
    return next()
  }

  if (publicRoute) {
    next()
  } else if (routeInit) {
    // Signed-in users hitting /signin go to loading to load profile and pick a home route
    (token || impersonated) ? next('/loading') : next()
  } else {
    if (token || impersonated) {
      // --- Bootstrap: until appReady, force /loading (with intended path in query) except for the checks below ---
      if (to.path !== '/loading' && from.path !== '/loading' && !store.getters.appReady) {
        // CRUD org routes: need edit permission; otherwise send user to their default area (reports or audits)
        if (!isEmpty(user) && crudRoutes.includes(to.fullPath) && !isAuthToEdit(user, impersonated)) {
          if (isAuthToReports(user, impersonated)) {
            next('/reports')
          } else if (isAuthToAudits(user, impersonated)) {
            next('/audits')
          }
          return
        }
        // Reports: need reports permission; else org home or audits fallback
        if (!isEmpty(user) && reportRoutes.includes(to.fullPath) && !isAuthToReports(user, impersonated)) {
          if (isAuthToEdit(user, impersonated)) {
            next('/organizationHome')
          } else {
            next('/audits')
          }
          return
        }
        // Audits home: need audits permission; else org home or reports fallback
        if (!isEmpty(user) && auditRoutes.includes(to.fullPath) && !isAuthToAudits(user, impersonated)) {
          if (isAuthToEdit(user, impersonated)) {
            next('/reports')
          } else {
            next('/organizationHome')
          }
          return
        }
        // Field survey setup entry: same audience as audits plus users linked via fieldSurveyIds
        if (!isEmpty(user) && to.path.startsWith('/fieldSurveys/') && !isAuthToFieldSurveys(user, impersonated)) {
          if (isAuthToEdit(user, impersonated)) {
            next('/organizationHome')
          } else if (isAuthToReports(user, impersonated)) {
            next('/reports')
          } else {
            next('/audits')
          }
          return
        }
        // Legacy add-* routes without going through loading: normalize to org home
        if (['AddDevice', 'AddField', 'AddCrop', 'EditUser', 'AddUser', 'ManageField'].includes(to.name)) {
          to = {
            path: '/organizationHome',
            query: {}
          }
        }
        // Defer to LoadingScreen + getUserData, then navigate to to.path
        next({ path: '/loading', query: {...to.query, to: to.path} })
      } else {
        next()
      }
    } else {
      next('/signin')
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js